module.exports = __webpack_public_path__ + "fonts/Lato-Regular.bd03a2cc.woff2";